export default __webpack_public_path__ + "static/media/linkbee-showcase-store.1df9c70c.svg";